module.exports = __webpack_public_path__ + "img/framee26.fdf09660.png";